import PPTXViewer from '@/components/common/pptx-viewer'

import type { ResourceType } from '@/types/resource.type'

interface PptxContentViewerProps {
  resource: ResourceType
  onLoadingComplete: () => Promise<void>
  className?: string
  isDownloadable?: boolean
}

export function PptxContentViewer({
  resource,
  onLoadingComplete,
  className,
  isDownloadable = false,
}: PptxContentViewerProps) {
  return (
    <PPTXViewer
      fileUrl={resource.url}
      onLoadingComplete={onLoadingComplete}
      className={className}
      isDownloadable={isDownloadable}
    />
  )
}
